import { SendAnalytics, GenerateLabel } from "../main";

const label = 'hal saham'
const analytics = SendAnalytics('Halaman Saham')

/** 👇 Users Click Search */
const ClickCariSaham = () => analytics({
  label: GenerateLabel({ label }),
  action: 'hal saham - click cari saham',
  name: 'click_cari_saham',
});

/** 👇 Users View Cari Saham */
const ClickSearchField = () => analytics({
  label: GenerateLabel({ label }),
  action: 'hal saham - click search field',
  name: 'click_search_field',
});

/** 👇 Users Input Saham & search */
const InputSaham = ({ emiten = '' }) => analytics({
  label: GenerateLabel({ label, emiten }),
  action: 'hal saham - input saham',
  name: 'input_saham',
});

/** 👇 Users View Emiten Profile */
const ViewEmiten = ({ emiten = '', category = '' }) => analytics({
  label: GenerateLabel({ label, emiten, category }),
  action: 'hal saham - view emiten',
  name: 'view_emiten',
});

const HalamanSaham = {
  ClickCariSaham,
  ClickSearchField,
  InputSaham,
  ViewEmiten,
};

export default HalamanSaham;
